import initialState from '../initialState'
import _ from 'lodash'
import { removeExtraSlashes } from '../../helper'

export function updateFileListBasedOnFilter(
  state = initialState.files,
  action,
) {
  switch (action.type) {
    case 'SET_FILE_DETAILS':
      return Object.assign({}, state, action.files)
    default:
      return state
  }
}

export function updateFileListFromResponse(
  state = initialState.fileList,
  action,
) {
  switch (action.type) {
    case 'SET_FILE_LIST_FROM_RESPONSE':
      return Object.assign({}, state, action.fileList)
    default:
      return state
  }
}

export function updateFolderList(folderList = {}, action) {
  switch (action.type) {
    case 'SET_FOLDER_LIST':
      return Object.assign({}, folderList, action.folderList)
    default:
      return folderList
  }
}

export function updateFilesToUpload(
  state = initialState.filesToUpload,
  action,
) {
  switch (action.type) {
    case 'SET_FILES_TO_UPLOAD':
      return action.filesToUpload
    case 'SET_FILE_UPLOAD_PROGRESS':
      const fileIndex = _.findIndex(state, function(item) {
        return (
          item.name === action.file.name &&
          removeExtraSlashes(`${item.basePath}/${item.name}`) ===
            removeExtraSlashes(`${action.file.basePath}/${action.file.name}`)
        )
      })
      state[fileIndex].progress = action.progress
      return state
    default:
      return state
  }
}

export function updateSelectedFolderToSearch(
  state = initialState.selectedFolderToSearch,
  action,
) {
  switch (action.type) {
    case 'SET_SELECTED_FOLDER_TO_SEARCH':
      return action.selectedFolderToSearch
    default:
      return state
  }
}

export default {
  updateFileListBasedOnFilter,
  updateFileListFromResponse,
  updateFolderList,
  updateFilesToUpload,
  updateSelectedFolderToSearch,
}
